import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HlmInput } from '@spartan-ng/helm/input';
import { HlmLabel } from '@spartan-ng/helm/label';

import { DetailCompagnonnageFormGroup } from '../jalon-detail-form-groups.types';
import { HlmFieldImports } from '@spartan-ng/helm/field';

@Component({
  selector: 'app-detail-compagnonnage',
  imports: [ReactiveFormsModule, HlmInput, HlmFieldImports, HlmLabel],
  templateUrl: './detail-compagnonnage.component.html',
})
export class DetailCompagnonnageComponent {
  readonly form = input.required<DetailCompagnonnageFormGroup>();
}
